import { Button, Col, Form, FormInstance, Input, Modal, Row } from "antd";
import FormLabel from "src/components/AntdCustomPart/FormLabel/FormLabel";
import ModalTitle from "src/components/AntdCustomPart/ModalTitle/ModalTitle";
import { SettingFugitiveStatus } from "src/entity/settings/fugitive";
import { generateErrorMessage } from "src/utils/error-message";

const FugitiveStatusModal = (props: {
  form: FormInstance;
  open: boolean;
  loading: boolean;
  mode: "insert" | "update";

  onCloseModal: () => void;
  onSave: (mode: "insert" | "update", data: SettingFugitiveStatus) => void;
}) => {
  const { form, loading, open, mode, onCloseModal, onSave } = props;

  const handleSave = async () => {
    try {
      await form.validateFields();
      const values = form.getFieldsValue();
      onSave(mode, values);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div>
      <Modal
        centered
        maskClosable={false}
        open={open}
        onCancel={onCloseModal}
        width={700}
        title={<ModalTitle title="Status" />}
        footer={
          <Row className="w-full border-t" justify={"end"}>
            <Button className="mt-4" key="submit" type="primary" loading={loading} onClick={handleSave}>
              Save
            </Button>
          </Row>
        }
      >
        <Form size="middle" layout="vertical" autoComplete="off" form={form} requiredMark={false}>
          <Row gutter={[16, 0]}>
            <Col xs={24}>
              <Form.Item label={<FormLabel label={"Status"} />} name="status">
                <Input />
              </Form.Item>
            </Col>

            <Col xs={24}>
              <Form.Item label={<FormLabel label={"Remark"} />} name="remark">
                <Input.TextArea rows={3}></Input.TextArea>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </div>
  );
};

export default FugitiveStatusModal;
